"use client";

import * as React from "react";
import { Star, Quote } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const reviews = [{
  id: 1,
  name: "Alessandro Rossi",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1585744/img/avatar_maria_silva.png",
  rating: 5,
  text: "Consulenza normativa di altissimo livello. Hanno guidato il nostro adeguamento tecnico con una precisione e una competenza fuori dal comune. Un partner indispensabile."
}, {
  id: 2,
  name: "Elena Bianchi",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1585744/img/avatar_joao_santos.png",
  rating: 5,
  text: "Corso di formazione eccellente. I contenuti sono estremamente operativi e subito applicabili in ambito aziendale. I docenti dimostrano una preparazione tecnica superiore."
}, {
  id: 3,
  name: "Marco Verdi",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1585744/img/avatar_ana_ferreira.png",
  rating: 5,
  text: "Un partner affidabile e reattivo per la conformità. Risposte rapide e una profonda conoscenza delle dinamiche industriali moderne. Consigliatissimo per ogni impresa."
}, {
  id: 4,
  name: "Giulia Neri",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1585744/img/avatar_pedro_oliveira.png",
  rating: 5,
  text: "Professionalità e trasparenza in ogni fase del processo. La qualità del supporto tecnico fornito è stata determinante per il successo del nostro progetto di certificazione."
}, {
  id: 5,
  name: "Roberto Bruno",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1585744/img/avatar_sofia_martins.png",
  rating: 5,
  text: "Punto di riferimento essenziale per le normative vigenti. Staff preparato e sempre disponibile per chiarimenti tecnici complessi. Eccellenza operativa garantita."
}];
export default function GoogleReviews() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}